import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";
import {
  inboundConsolidationAddressSchema,
  inboundConsolidationRouteEndpointSchema,
} from "./inbound-consolidation-address";
import { InboundConsolidationLifecycleStatusSchema } from "./inbound-consolidation-lifecycle";

const inboundConsolidationLegSchema_ = z.object({
  sequence: z.number(),
  origin: inboundConsolidationRouteEndpointSchema,
  destination: inboundConsolidationRouteEndpointSchema,
  routeLabel: z.enum(["shared_hub", "final_mile"]),
  carrier: z.string().nullable(),
  trackingCode: z.string().nullable(),
  trackingUrl: z.string().nullable(),
});
export const inboundConsolidationLegSchema: z.ZodType<InboundConsolidationLeg> =
  inboundConsolidationLegSchema_;
export interface InboundConsolidationLeg extends z.infer<
  typeof inboundConsolidationLegSchema_
> {}

const inboundConsolidationCartonSchema_ = z.object({
  id: z.string(),
  cartonNumber: z.number(),
  legs: z.array(inboundConsolidationLegSchema),
});
export const inboundConsolidationCartonSchema: z.ZodType<InboundConsolidationCarton> =
  inboundConsolidationCartonSchema_;
export interface InboundConsolidationCarton extends z.infer<
  typeof inboundConsolidationCartonSchema_
> {}

const inboundConsolidationDetailsSchema_ = z.object({
  id: z.string(),
  reference: z.string(),
  status: InboundConsolidationLifecycleStatusSchema,
  itemCount: z.number(),
  batchOrigin: inboundConsolidationRouteEndpointSchema,
  batchDestination: inboundConsolidationRouteEndpointSchema,
  finalMileDestination: inboundConsolidationAddressSchema.nullable(),
  cartons: z.array(inboundConsolidationCartonSchema),
  createdAt: z.date(),
  updatedAt: z.date(),
});
export const inboundConsolidationDetailsSchema: z.ZodType<InboundConsolidationDetails> =
  inboundConsolidationDetailsSchema_;
export interface InboundConsolidationDetails extends z.infer<
  typeof inboundConsolidationDetailsSchema_
> {}

export const getInboundConsolidationDetails = unaryRpc({
  name: "getInboundConsolidationDetails" as const,
  input: z.object({ consolidationId: z.string() }),
  output: inboundConsolidationDetailsSchema,
});
